import AppRoutes from './App.routes';
import { AppThemeProvider } from '../providers/AppThemeProvider';

const App = () => <AppThemeProvider><AppRoutes /></AppThemeProvider>;
export default App;
